/** A `?ref=` is acted on once per value; list refetches re-run the effect and must not re-open the tool */
export const shouldHandleRef = ({ ref, handled }: { ref: string | undefined; handled: string | undefined }) =>
  Boolean(ref) && ref !== handled
